import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { BaseDialogComponent } from '@helpers/base';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
    selector: 'multiprompt-dialog',
    templateUrl: './multiprompt.dialog.html',
    styleUrls: ['./dialog.scss'],
    standalone: true,
    imports: [
        MatToolbarModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        NgFor,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        TranslateModule,
    ],
})
export class MultiPromptDialog extends BaseDialogComponent implements OnInit {
    public title: string;
    public fields: { value: string; label: string; key?: string }[];
    public form: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<MultiPromptDialog>,
        public fb: UntypedFormBuilder,
    ) {
        super(dialogRef);
    }

    ngOnInit() {
        // this.form = this.fb.group({
        //     prompt: [this.value, Validators.required]
        // });
    }

    submit() {
        // const value = this.form.value;

        this.dismiss(this.fields);
    }
}
